<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h6
          class="text-h6 font-weight-medium grey--text text--darken-1 pb-3"
        >
          Inclusion Criteria
        </h6>
        <review-criteria-form
          :review="review"
          :review-criteria="inclusionCriteria"
          criteria-type="INCLUSION"
          @save-criteria="$emit('save-criteria', $event)"
          @delete-criteria="$emit('delete-criteria', $event)"
        />
      </v-col>
      <v-col>
        <h6
          class="text-h6 font-weight-medium grey--text text--darken-1 pb-3"
        >
          Exclusion Criteria
        </h6>
        <review-criteria-form
          :review="review"
          :review-criteria="exclusionCriteria"
          criteria-type="EXCLUSION"
          @save-criteria="$emit('save-criteria', $event)"
          @delete-criteria="$emit('delete-criteria', $event)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ReviewCriteriaForm from './ReviewCriteriaForm';
import { Review } from '@/models';

export default {
  name: 'ReviewCriteriaSettingsPanel',
  components: { ReviewCriteriaForm },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  computed: {
    reviewCriteria() {
      return this.review.reviewCriteria;
    },
    inclusionCriteria() {
      return this.reviewCriteria.filter(
        (criteria) => criteria.criteriaType === 'INCLUSION'
      );
    },
    exclusionCriteria() {
      return this.reviewCriteria.filter(
        (criteria) => criteria.criteriaType === 'EXCLUSION'
      );
    },
  },
};
</script>
